/** 1.4.0 portal strings, stream G3 (the supplier's grouped My deliveries, "Series › Season"): keys under groups. G3's file. */
export const GROUPS_G3_STRINGS = {
  // A group assignment's deliveries under one heading: the path of the placeholders' series and season.
  'groups.heading': '{path}',
  'groups.countOne': '1 delivery in this group',
  'groups.count': '{n} deliveries in this group',
  // The episode's number in front of its delivery ("No. 3").
  'groups.number': 'No. {n}',
} as const;
